import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { IdCategoriesState, IdCategoriesStateDataItem } from 'model/dashboardCategories/dCategoriesReducer'
import { Trans } from '@lingui/macro'
import { useInputChange } from 'hooks/useInputChange'
import { Alert } from 'components/UI/Alert/Alert'
import { InputText } from 'components/UI/InputText/InputText'
import { Button } from 'components/UI/Button/Button'
import {
    dCategoriesEditItemSagaAC
} from 'model/dashboardCategories/dCategoriesActionCreators'
import { changeCategoriesItem } from 'model/dashboardCategories/dCategoriesAPI';
import { Loader } from 'components/UI/Loader/Loader'
import { errorGenerator } from 'model/system/utils';

// Type
export type typePopupEdit = {
    setOpenPopup: React.Dispatch<React.SetStateAction<boolean>>
}


// Component
export const PopupEdit: React.FC<typePopupEdit> = ({ setOpenPopup }) => {

    const dispatch = useDispatch()

    // System
    const dataObject = useSelector((state: { dCategories: IdCategoriesState }) => state.dCategories.detailItem)
    const pagination = useSelector((state: { dCategories: IdCategoriesState }) => state.dCategories.pagination)

    const filters = useSelector((state: { dCategories: IdCategoriesState }) => state.dCategories.filters)

    // Form data
    const {
        value: nameValue,
        changeValueHandler: nameChangeValueHandler
    } = useInputChange(dataObject ? dataObject.name : '')

    const [ loader, setLoader ] = useState(false)


    // Validation
    const [ validationObj, setValidationObj ] = useState({ requiredName: true, uniqueName: true })


    useEffect(() => {
        if (nameValue.trim() === '') {
            setValidationObj((v) => {return { ...v, ...{ requiredName: false, uniqueName: true } }})
        } else {
            setValidationObj((v) => {return { ...v, ...{ requiredName: true, uniqueName: true } }})
        }
    }, [ nameValue ])


    const onSaveHandler = async (e: React.FormEvent) => {
        e.preventDefault()

        if (nameValue === dataObject!.name) {
            setOpenPopup(false)
            return
        }

        setLoader(true)

        const dataEditObject: IdCategoriesStateDataItem = {
            id: dataObject!.id,
            name: nameValue.trim(),
            deleted: dataObject!.deleted
        }

        const response = await changeCategoriesItem({ dataObject: dataEditObject })

        if (response.status === 200) {
            dispatch(dCategoriesEditItemSagaAC(filters, {
                page: pagination.pageNumber,
                size: pagination.itemsPerPage!
            }))

            setOpenPopup(false)
        } else if (response.status === 400) {

            if (response.data?.description && ( response.data.description as string ).includes(`Detail: Key (name)=(${ dataEditObject.name }) already exists`)) {

                setValidationObj({ ...validationObj, ...{ uniqueName: false } })

            } else {
                errorGenerator(response)
            }

        } else {
            errorGenerator(response)
        }

        setLoader(false)

    }

    return (
        <>
            { dataObject
                ? <>
                    <form className="sm:w-80">

                        <input type="hidden" value={ dataObject.id }/>

                        <div>
                            <div>
                                <InputText
                                    labelClassName="text-left"
                                    id="name"
                                    name="name"
                                    value={ nameValue }
                                    onChange={ nameChangeValueHandler }
                                    label={ <Trans>Category name</Trans> }
                                    errorMessage={ validationObj.requiredName ? ( validationObj.uniqueName ? undefined :
                                        <Trans>This name already exists</Trans> ) : <Trans>Required field</Trans> }
                                    required={ true }
                                    maxLength={ 150 }
                                />

                            </div>
                        </div>

                        <div className="flex gap-4 mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">

                            <Button type="submit"
                                    disabled={ !validationObj.requiredName || !validationObj.uniqueName  || loader }
                                    label={ <Trans>Save</Trans> }
                                    onClick={ (e) => onSaveHandler(e) }
                            />
                            <Button type="button" secondary={ true } label={ <Trans>Cancel</Trans> }
                                    onClick={ () => setOpenPopup(false) }/>

                        </div>
                        { loader ? <Loader/> : null }
                    </form>
                </>
                : <Alert type="error" title={ <Trans>Have no data.</Trans> }/>
            }
        </>
    )
}
